export default __webpack_public_path__ + "static/media/online-support.0f855d73.svg";